import { useInfiniteQuery, useQuery } from 'react-query';
import {
  getActiveHeroConversations,
  getArchivedHeroConversations,
  getHeroConversationById,
} from './heroApiClient';
import { HeroConversation } from '../../model';
import { useContext } from 'react';
import { AuthenticationContext } from '../../components';

export const useGetActiveHeroConversations = () => {
  const { isAuthenticated } = useContext(AuthenticationContext);
  return useQuery(['getActiveHeroConversations'], getActiveHeroConversations, {
    enabled: isAuthenticated,
    suspense: true,
    staleTime: Infinity,
    select: (conversations: HeroConversation[]) =>
      conversations.sort(
        (a, b) =>
          new Date(b.lastReceivedMessage).getTime() -
          new Date(a.lastReceivedMessage).getTime(),
      ),
  });
};

export const useGetArchivedHeroConversations = () => {
  const { isAuthenticated } = useContext(AuthenticationContext);
  return useInfiniteQuery(
    ['getArchivedHeroConversations'],
    ({ pageParam }) => getArchivedHeroConversations(pageParam as number),
    {
      suspense: true,
      staleTime: Infinity,
      getNextPageParam: (lastPage, allPages) => {
        const totalPageCount = Math.ceil(lastPage.totalCount / 30);
        const currentPageCount = allPages.length;
        if (currentPageCount <= totalPageCount) {
          return currentPageCount;
        }
      },
      enabled: isAuthenticated,
    },
  );
};

export const useGetHeroConversationById = (conversationId?: string) => {
  return useQuery(
    ['getHeroConversationById', conversationId],
    () => {
      if (!conversationId) {
        return;
      }
      return getHeroConversationById(conversationId);
    },
    {
      staleTime: Infinity,
    },
  );
};
